import { useSearchParams } from "react-router-dom";
import AddLookup from "../../../Components/InputComponents/AddLookup";

function AddBranch() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/BranchLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Add Branch"
      alert="Branch Added Successfully"
      addDataAPIEndpoint="/Branch/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Branch",
              name: "BL_Name",
              required: true, // Validation rule added here
              maxLength: 255,
            },
            {
              type: "select",
              label: "Status",
              name: "BL_Status",
              required: true, // Validation rule added here
              options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        BL_Name: {
          required: true,
        },
        BL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddBranch;
